import { IntlMessageID } from "~/providers/I18nProvider";

export const LoginError: Record<
  string,
  { message: IntlMessageID; description?: IntlMessageID }
> = {
  //Keys come from backend
  UserNamePasswordError: {
    message: "Login.Error.EmailOrPasswordIsIncorrect",
    description: "Login.Error.EmailOrPasswordIsIncorrect",
  },
  UserSSONotEnabled: {
    message: "Login.Notification.UserSSONotEnabled.Message",
    description: "Login.Notification.UserSSONotEnabled.Description",
  },
  UserSSOEnabled: {
    message: "Login.Notification.UserSSOEnabled.Message",
    description: "Login.Notification.UserSSOEnabled.Description",
  },
  UserLocked: {
    message: "Login.Notification.UserLocked.Message",
    description: "Login.Notification.UserLocked.Description",
  },
};

export const EXPIRED_PASSWORD_ERROR = "UserPasswordExpired";
